<template>
  <div>
    <v-row v-if="isShowFoto">
      <v-col cols="12">
        <v-responsive>
          <v-img :src="fotoUrl" :aspect-ratio="3 / 4" contain></v-img>
        </v-responsive>
        <v-btn depressed dark block class="mt-2" color="red" @click="destroyFileConfirm('foto')">
          <v-icon left>mdi-trash-can</v-icon>
          Remover
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-img
          src="@/assets/default_avatar.png"
          :aspect-ratio="3 / 4"
          class="mb-0"
        />
      </v-col>
      <v-col cols="6">
        <v-btn
          depressed
          block
          dark
          small
          color="primary"
          @click="toggleCapturaFotoForm"
        >
          <v-icon left>mdi-camera-outline</v-icon>
          Captura
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
          depressed
          block
          dark
          small
          color="secondary"
          @click="toggleUploadFotoForm"
        >
          <v-icon left>mdi-cloud-upload-outline</v-icon>
          Upload
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import { Cropper } from 'vue-advanced-cropper';
import { mapActions, mapState } from 'vuex';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';

export default {
  name: 'CameraCapturaFoto',
  // components: { Cropper },
  data: () => ({
  }),
  computed: {
    ...mapState('pessoa', ['data']),
    isShowFoto() {
      return !!(this.data && this.data.foto);
    },
    fotoUrl() {
      return this.isShowFoto ? this.data.foto.foto_url : null;
    },
  },
  created() {
    // this.checkIsCamera();
  },
  methods: {
    ...mapActions('pessoa', [
      'destroyFile',
      'toggleUploadFotoForm',
      'toggleCapturaFotoForm',
    ]),
    destroyFileConfirm(item) {
      confirmDestroyAlert(item).then((result) => {
        if (result.value) {
          this.destroyFile(item)
            .then(() => {
              toastMessage.successDestroy('Foto excluída com sucesso');
            })
            .catch(() => toastMessage.errorDestroy('Erro ao excluir foto'));
        }
      });
    },
  },
  beforeDestroy() {
    this.stopClear();
  },
};
</script>
